<div class="background-snackbar {{data.status}} p-r-20 p-l-20 p-t-12 p-b-12">

  <div class="d-flex justify-between">

    <header class="m-r-40" [ngClass]="{'item-center': !data.title}">
      @if(data.title){
        <h1 class="title m-b-10">{{ data.title | translate }}</h1>
      }
      <p class="sub-title m-0">{{ data.message | translate }}</p>
    </header>
    <div class="d-flex flex-column justify-center align-item-center">
      <button class="default-mini mat-elevation-z0" (click)="closeDialog()">
        <fa-icon [icon]="['fal','xmark']" [fixedWidth]="false" class="font-14"></fa-icon>
      </button>

    </div>
  </div>

</div>
